import React from 'react';

import DashboardWidgetWrapper from '../DashboardWidgetWrapper';

const UploadMediaWidget = (props) => {
	return (
		<DashboardWidgetWrapper label={'Upload Media'}>
			<p>Hello</p>
		</DashboardWidgetWrapper>
	);
};

UploadMediaWidget.propTypes = {};

export default UploadMediaWidget;
